<div class="web-chat-side">
    <button class="close-btn" (click)="close.emit()">&times;</button>
    <iframe
        [src]="iframeUrl"
        width="100%"
        height="100%"
        frameborder="0"
        allowfullscreen>
    </iframe>
</div>

<div class="image-modal-backdrop" *ngIf="isModalOpen" (click)="closeImageModal()">
  <div class="image-modal-content" (click)="$event.stopPropagation()">
    <span class="image-modal-close" (click)="closeImageModal()">&times;</span>
    <img [src]="modalImageUrl" alt="Imagen ampliada" class="image-modal-image">
  </div>
</div>